import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "size-select" }
const _hoisted_2 = {
  key: 0,
  class: "size-select__purchase-decision-info"
}
const _hoisted_3 = { class: "size-select__container" }

import { computed, inject, PropType } from 'vue';

import SizeButton from './SizeButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SizeSelect',
  props: {
  sizes: {
    type: Array as PropType<any[]>,
    required: true,
  },
  selectedSize: {
    type: Object,
    default: null,
  },
  showCheckmark: {
    type: Boolean,
    default: false,
  },
},
  emits: ['select'],
  setup(__props, { emit }) {

const props = __props





const addToCartContext = inject('addToCartContext') as any;

const purchaseDecisionInfo = computed(() => {
  return addToCartContext.purchaseDecisionInfo.value;
});

function isSelected(size) {
  if (!size || !props.selectedSize) {
    return size === props.selectedSize;
  }
  return size.systemId === props.selectedSize.systemId;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(purchaseDecisionInfo))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(purchaseDecisionInfo)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sizes, (size) => {
        return (_openBlock(), _createBlock(SizeButton, {
          key: size.systemId,
          size: size,
          class: _normalizeClass({
          'size-select--selected': isSelected(size),
          'size-select--show-checkmark': __props.showCheckmark && isSelected(size),
        }),
          onSelect: _cache[0] || (_cache[0] = ($event: any) => (emit('select', $event)))
        }, null, 8, ["size", "class"]))
      }), 128))
    ])
  ]))
}
}

})